import omit from 'lodash/omit';

// Sanitize the result for download by removing the application specific
// property __id from the result.
const sanitizeDownload = geojson => {
  return Object.assign({}, geojson, {
    features: [
      ...geojson.features.map(feature => {
        return Object.assign({}, feature, {
          properties: omit(feature.properties, ['__id'])
        });
      })
    ]
  });
};

export { sanitizeDownload };
